<template>
  <div class="ArtistPrizes">
    <div class="ProfilePrizes">
      <div class="row mt-5" v-for="(prize, index) in artist.prizes" v-if="!per || index < per">
        <div class="col-xs-2">
          <i
            class="ArtistPrizes-Icon fal fa-award"
            :class="{
              'ArtistPrizes-Icon-Gold': ['winner', 'finalist', 'category_winner'].includes(prize.achievement_value),
            }"
          ></i>
        </div>
        <div class="col-xs-10">
          <div>{{ prize.achievement }}</div>
          <div>{{ prize.name }} {{ prize.year }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArtistPrizes",
  props: ["artist", "per"],
}
</script>

<style lang="scss" scoped>
.ArtistPrizes {
  &-Icon {
    height: 40px;
    width: 40px;
    color: #000000;
  }

  &-Icon-Gold {
    height: 40px;
    width: 40px;
    color: #d4af37 !important;
  }
}
</style>
